import React, { memo, useContext, useState } from 'react'
import { TenantsContext } from '../../../context/tenants.context'
import { RubroPosible } from '../../Integraciones/types/responses-productos'
import PosiblesRubros from './tablaRubrosPosibles'
import DropFile from './dropFile'
import { connect } from 'react-redux'
import setRedirectUrl from '../../../redux/actions/redirection/setRedirectUrl'
import Navbar from '../../../components/Navbar'
import { IconButton, useMediaQuery, useTheme } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router'
import { prediccionRubro } from '../../AdminProducts/services/rubros.service'
import { hash } from '../../../utils/hashFunction'

const Prediccion: React.FC<any> = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [droppedFile, setDroppedFile] = useState<File | null>(null)
  const [rubros, setRubros] = useState<RubroPosible[]>(null)
  const { tenant } = useContext(TenantsContext)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()

  const handleConsultar = async () => {
    if (!droppedFile) return
    setLoading(true)

    try {
      const base64 = await toBase64(droppedFile)
      const clave = await hash(droppedFile.name + 'lugares2017')
      const payload = [
        {
          filename: droppedFile.name,
          imagenBase64: base64
        }
      ]
      await prediccionRubro(tenant, payload, clave).then((res) => {
        setRubros(res.data.data[0]?.results)
      })
    } catch (err) {
      console.error('Error al consultar:', err)
    } finally {
      setLoading(false)
    }
  }

  // función auxiliar para convertir archivo a Base64
  const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const result = reader.result as string
        const base64Data = result.split(',')[1]
        resolve(base64Data)
      }
      reader.onerror = (error) => reject(error)
    })

  const handleLeft = () => {
    navigate('/prediccion-imagen')
    setRubros(null)
  }

  return (
    <>
      <Navbar title="Predicción de Imagen" />
      <div>
        {rubros ? (
          <>
            <IconButton onClick={handleLeft} sx={{ marginTop: '10px', marginLeft: isMobile ? '10px' : '20px' }}>
              <ArrowBackIcon />
            </IconButton>
            <PosiblesRubros rubros={rubros} loading={loading} isMobile={isMobile} />
          </>
        ) : (
          <DropFile
            loading={loading}
            setDroppedFile={setDroppedFile}
            droppedFile={droppedFile}
            handleConsultar={handleConsultar}
            isMobile={isMobile}
          />
        )}
      </div>
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  // resetToaster,
  setRedirectUrl
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(Prediccion))
